export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/5ba84b7c5997e2a9223c26a23a6fa17e.svg";